<modal-header title="Clock In {{user.person.name}}"></modal-header>
<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col size-xs="6">
                <ion-button class="selection-option"
                            color="primary"
                            (click)="close('TIPPED')">
                    <div class="option-container">
                        Tipped
                    </div>
                </ion-button>
            </ion-col>
            <ion-col size-xs="6">
                <ion-button class="selection-option"
                            color="dark"
                            (click)="close('UNTIPPED')">
                    <div class="option-container">
                        Un-tipped
                    </div>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>

<modal-footer submitLabel="Cancel" (submitClicked)="close()"></modal-footer>
